// Menütexte: nur breitenbestimmende Einträge kürzen; Seitentitel behalten ihre bisherigen Keys.
export const navigationMenuDe = {
  "Menu.navigation": "Menü",
  "Menu.organisation": "Organisation",
  "Menu.payments": "Zahlungen",
  "Menu.appointments": "Kalender & Termine",
  "Menu.tenantData": "Daten",
  "Menu.backups": "Sicherungen",
  "Menu.forceDelete": "Zwangslöschung",
  "Menu.versions": "Versionen",
  "Menu.ai": "KI-Verwaltung",
  "Menu.tenantManagement": "Verwaltung",
} as const;

export const navigationMenuEn = {
  "Menu.navigation": "Menu",
  "Menu.organisation": "Organization & Users",
  "Menu.payments": "Payments & Billing",
  "Menu.appointments": "Appointments",
  "Menu.tenantData": "Data",
  "Menu.backups": "Backups",
  "Menu.forceDelete": "Force delete",
  "Menu.versions": "Versions",
  "Menu.ai": "AI administration",
  "Menu.tenantManagement": "Management",
} as const;

